import React, { useContext } from "react";
import { CommonContext } from "../hooks/CommonContext";
import { FaMicrophone, FaMicrophoneSlash } from "react-icons/fa";

const AudioToggleButton = () => {
  const { toggleAudio, audioEnabled } = useContext(CommonContext);
  return (
    <button
      onClick={toggleAudio}
      title={audioEnabled ? "Mute microphone" : "Unmute microphone"}
      className={`ftr-btn${!audioEnabled ? " ftr-off" : ""}`}
    >
      {audioEnabled ? <FaMicrophone /> : <FaMicrophoneSlash />}
    </button>
  );
};

export default AudioToggleButton;